var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[_c('secretary-add-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","memberDetails":_vm.memberDetails,"edit":_vm.edit},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2766a604","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/Add/SecretaryAdd.vue
// module id = 813
// module chunks = 30